export const ds_LinksLayoutBlock_Entry = `
    fragment ds_LinksLayoutBlock_Entry on ds_LinksLayoutBlock_Entry {
        id
        canonicalUid
        links_ColorPalette
        links_ColorTheme
        links_TextColor
        links_ColumnsDesktop
        links_ContentAlignment
        links_Padding
        links_Links {
            text
            target
            title
            url
            ariaLabel
            ... on links_Links_Custom_LinkType {
                description
                icon {
                    name
                    set
                    type
                }
            }
            ... on links_Links_Entry_LinkType {
                description
                icon {
                    name
                    set
                    type
                }
            }
            ... on links_Links_Url_LinkType {
                description
                icon {
                    name
                    set
                    type
                }
            }
            ... on links_Links_Phone_LinkType {
                description
                icon {
                    name
                    set
                    type
                }
            }
            ... on links_Links_Email_LinkType {
                description
                icon {
                    name
                    set
                    type
                }
            }
        }
    }
`
